function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.90476 7.5C9.62862 7.5 9.40476 7.72386 9.40476 8C9.40476 8.27614 9.62862 8.5 9.90476 8.5V7.5ZM16 8H16.5C16.5 7.72386 16.2761 7.5 16 7.5V8ZM15.5 14.123C15.5 14.3991 15.7239 14.623 16 14.623C16.2761 14.623 16.5 14.3991 16.5 14.123H15.5ZM7.64564 15.6473C7.45083 15.843 7.45155 16.1595 7.64725 16.3544C7.84296 16.5492 8.15954 16.5485 8.35436 16.3527L7.64564 15.6473ZM15.8968 8.77592C16.0916 8.58022 16.0909 8.26364 15.8952 8.06882C15.6995 7.874 15.3829 7.87472 15.1881 8.07043L15.8968 8.77592ZM9.90476 8.5H16V7.5H9.90476V8.5ZM15.5 8V14.123H16.5V8H15.5ZM8.35436 16.3527L15.8968 8.77592L15.1881 8.07043L7.64564 15.6473L8.35436 16.3527Z",
  fill: "#A4A5A8"
});

function SvgExternalLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/ExternalLink.16d280632ebad3aabefdb046aba0dfe8.svg";
export { ForwardRef as ReactComponent };